import Translate from 'lang/Translate'

const InlineErrorWrapper = ({ errorCode }: { errorCode: string }) => {
  return (
    <div className='error-msg-wrapper'>
      <Translate text={`Errors.${errorCode}`} />
    </div>
  )
}

export default InlineErrorWrapper